<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'SNMP Trap Enable'" style="height: 100%">
        <div style="margin-left: 10px">
          <input
            type="radio"
            id="snmpTrapsEnable"
            value="enable"
            v-model="snmpTrapAdmin"
          />
          <label for="snmpTrapsEnable">Traps Enable</label>
          <input
            type="radio"
            id="snmpTrapsDisable"
            value="disable"
            v-model="snmpTrapAdmin"
          />
          <label for="snmpTrapsDisable">Traps Disable</label>
          <button
            type="button"
            class="btn btn-primary"
            @click="snmpTrapsEnableSet()"
          >
            {{ "Apply" }}
          </button>
        </div>
      </block-cntr>
      <block-cntr :btitle="'Trap Host Config'" style="height: 410px">
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllHost"
                />
                <label for="idSelectAllHost"></label>
              </th>
              <th
                v-for="(value, key) in snmpTrapHost.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in snmpTrapHost.data"
              :key="row.index"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div>
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectTrapHost' + index"
                  />
                  <label :for="'idRowSelectTrapHost' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.ip }}</div>
              </td>
              <td>
                <div>{{ row.version }}</div>
              </td>
              <td>
                <div>{{ row.securityName }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!--配置操作-->
        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Trap Host Config'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="host">Host IP</label>
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters('ip', trapHostForm.ip),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="host"
                    v-model="trapHostForm.ip"
                    placeholder="A.B.C.D"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('ip', trapHostForm.ip)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("ip", trapHostForm.ip) }}
                  </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="snmpVersion"
                  >Version</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="snmpVersion"
                    v-model="trapHostForm.version"
                  >
                    <option label="1" value="1"></option>
                    <option label="2c" value="2c"></option>
                    <!-- 屏蔽v3选项
                      <option label="3" value="3"></option>
                      -->
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="securityName"
                  >Security Name</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'name',
                      trapHostForm.securityName
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="securityName"
                    v-model="trapHostForm.securityName"
                    placeholder="STRING<1-32>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'name',
                        trapHostForm.securityName
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("name", trapHostForm.securityName) }}
                  </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "uniqueGemport",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      snmpTrapAdmin: "",
      snmpTrapHost: "",
      isShowAddTable: false,
      isSelectAll: false,
      iBox: {},
      trapHostForm: {
        ip: "",
        version: "",
        securityName: "",
      },
    }
  },

  created() {
    this.loadSnmpTrapEnable()
    this.loadSnmpTrapHost()
  },

  methods: {
    loadSnmpTrapEnable() {
      get("snmpTrapEnable")
        .then((res) => {
          this.snmpTrapAdmin = res.data.admin
        })
        .catch((err) => {})
    },
    loadSnmpTrapHost() {
      get("snmpTrapHost")
        .then((res) => {
          this.snmpTrapHost = res.data
        })
        .catch((err) => {
          this.snmpTrapHost = en.snmpTrapHost
        })
    },

    snmpTrapsEnableSet() {
      var postData = {
        admin: this.snmpTrapAdmin,
      }

      post("snmpTrapEnable", postData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadSnmpTrapEnable()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    clkAdd() {
      this.isShowAddTable = true
      this.resetField()
      this.selectNull()
    },

    clkDel() {
      var delData = {
        trapHost: [],
      }

      for (let i = 0; i < this.snmpTrapHost.data.length; i++) {
        if (this.snmpTrapHost.data[i].selected) {
          delData.trapHost.push({
            ip: this.snmpTrapHost.data[i].ip,
            name: this.snmpTrapHost.data[i].securityName,
            version: this.snmpTrapHost.data[i].version,
          })
        }
      }
      if (delData.trapHost.length == 0) {
        return
      }

      post("snmpTrapHostDelete", delData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadSnmpTrapHost()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.loadSnmpTrapHost()
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var trapHostFormTmp = {
        ip: "",
        version: "",
        securityName: "",
      }

      this.trapHostForm = trapHostFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.snmpTrapHost.data.length; i++) {
        if (this.isSelectAll) {
          this.snmpTrapHost.data[i].selected = true
        } else {
          this.snmpTrapHost.data[i].selected = false
        }
      }
    },

    selectNull() {
      for (let i = 0; i < this.snmpTrapHost.data.length; i++) {
        this.snmpTrapHost.data[i].selected = false
      }
      this.isSelectAll = false
    },
    clkApply() {
      var trapHostConfig = {
        ip: this.trapHostForm.ip,
        version: this.trapHostForm.version,
        securityName: this.trapHostForm.securityName,
      }

      if (
        this.trapHostForm.ip == "" ||
        this.checkParameters("ip", this.trapHostForm.ip) ||
        this.trapHostForm.version == "" ||
        this.trapHostForm.securityName == "" ||
        this.checkParameters("name", this.trapHostForm.securityName)
      ) {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }

      post("snmpTrapHostConfig", trapHostConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadSnmpTrapHost()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.selectNull()
    },

    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "ip") {
        if (
          value.match(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/) ==
          null
        ) {
          return "ip address must be inputted with A.B.C.D "
        } else {
          var id = value.split(".")
          let ip0 = Number(id[0])
          let ip1 = Number(id[1])
          let ip2 = Number(id[2])
          let ip3 = Number(id[3])
          if (
            ip0 < 0 ||
            ip0 > 255 ||
            ip1 < 0 ||
            ip1 > 255 ||
            ip2 < 0 ||
            ip2 > 255 ||
            ip3 < 0 ||
            ip3 > 255 ||
            (ip0 == 0 && ip1 == 0 && ip2 == 0 && ip3 == 0)
          )
            return "invalid ip address"
        }
      } else if (type == "name") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 32
        ) {
          return "invalid security name"
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
